/* eslint-disable */
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';

export async function export_json_to_excel_new(header, data, fileName, sheetName = 'Sheet1') {
  try {
    // 创建一个新的工作簿
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet(sheetName);
     // 初始化列宽数组
     const columnWidths = Array(header.length).fill(0);
     const columns =[]

     // 添加表头并计算初始列宽
     header.forEach((column, index) => {
       const columnHeader = column.header || '';
       columns.push({
         header: columnHeader,
         key: column.key || columnHeader,
         width: columnHeader.toString().length + 2 // 初始宽度为表头长度加一些额外空间
       });
       columnWidths[index] = columnHeader.toString().length;
     });
     worksheet.columns = columns
 
     // 添加数据行并更新列宽
     data.forEach((row, rowIndex) => {
       const rowData = {};
       header.forEach((column, colIndex) => {
         const cellValue = row[column.key] !== undefined ? row[column.key] : '';
         rowData[column.key] = cellValue;
 
         // 更新列宽
         const cellText = cellValue.toString();
         if (cellText.length > columnWidths[colIndex]) {
           columnWidths[colIndex] = cellText.length;
         }
       });
       worksheet.addRow(rowData);
     });
 
     // 设置每列的宽度
     worksheet.columns.forEach((column, index) => {
       column.width = columnWidths[index] + 2; // 加上一些额外的空间
     });

    // 将工作簿转换为 ArrayBuffer
    const buffer = await workbook.xlsx.writeBuffer();
    // 创建 Blob 对象
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    // 使用 FileSaver.js 保存文件
    saveAs(blob, `${fileName}.xlsx`);
  } catch (error) {
    console.error('导出 Excel 时发生错误:', error);
  }

}

